import script from "./Teacher.vue?vue&type=script&setup=true&lang=ts"
export * from "./Teacher.vue?vue&type=script&setup=true&lang=ts"

import "./Teacher.vue?vue&type=style&index=0&id=71e16941&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.0_@vue+comp_e6e64a637db6d84575551e338fa99c34/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71e16941"]])

export default __exports__